import {
  AuthTypeEnums,
  ResourceAuth,
  ResourceCodeEnums,
} from "@/api/dmp_common/interface";
import GlobalContext from "models/globalContext";
import { useRouter } from "next/router";
import { useContext, useMemo } from "react";
import { MenuContext } from "views/menu_layout/layout/context";

/**
 *  对于某个resourceCode是否有权限
 * @param resourceAuthList 后端返回的权限列表
 * @param resourceCode 资源模块
 * @param isShow 是否是展示权限
 */
export const hasAuth = (
  resourceAuthList: ResourceAuth[] = [],
  resourceCode: ResourceCodeEnums = ResourceCodeEnums.HOME,
  isShow?: boolean
) => {
  return !!resourceAuthList.find((item) => {
    if (isShow) {
      return item.resourceCode === resourceCode;
    }

    return (
      item.resourceCode === resourceCode && item.authType === AuthTypeEnums.HAS
    );
  });
};

/**
 * 判断页面权限的hook
 * @notice 不传参的话要在MenuContext和GlobalContext内使用
 * @param resourceCode 资源模块, 如果是判断某个左侧menu对应的页面则不需要传入
 * @returns [是否有权限, 权限信息]
 */
export const useAuth = (
  resourceCode?: ResourceCodeEnums | string
): [boolean, ResourceAuth | undefined] => {
  const { resourceAuthList } = useContext(GlobalContext);
  const { asPath } = useRouter();
  const { activeMenu } = useContext(MenuContext);

  const pageRoute = useMemo(() => {
    return asPath.replace(/\?.+/, "").split("/").pop();
  }, [asPath]);

  const auth = useMemo(() => {
    // 优先传入的resourceCode; 其次是左侧菜单的name; 最后是当前页面的路径
    return resourceAuthList.find(
      (item) =>
        item.resourceCode === (resourceCode ?? activeMenu?.name ?? pageRoute)
    );
  }, [activeMenu?.name, resourceAuthList, resourceCode]);

  return [auth?.authType === AuthTypeEnums.HAS || activeMenu?.show, auth];
};
